import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { getPracticasAfiliado } from '../../services/Busquedas/Practicas';

const PracticaAutocomplete = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [practicaLabel, setPracticaLabel] = React.useState('Seleccioná la práctica');

  React.useEffect(() => {
    const getPractica = async () => {
      const practicas = await getPracticasAfiliado();
      setOptions(practicas);
    };

    try {
      if (options && options.length === 0) {
        getPractica();
      }
    } catch (err) {
      console.error(err);
    }
  }, [options]);

  const handleChange = (event, newValue) => {
    props.onSelectPractica(newValue);
    setPracticaLabel('Práctica');
  };

  return (
    <Autocomplete
      id='practica-autocomplete'
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option.idPractica === value.idPractica}
      getOptionLabel={(a) => `${a.codigo} - ${a.descripcion}`}
      onChange={handleChange}
      options={options}
      loading={options && options.length === 0}
      renderInput={(params) => (
        <TextField
          id='textPractica'
          {...params}
          label={practicaLabel}
          variant='standard'
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {options && options.length === 0 ? (
                  <CircularProgress color='inherit' size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
});

export default PracticaAutocomplete;
